export default {"src":"/_next/static/media/circle-segment.17c81714.svg","height":841,"width":1160,"blurWidth":0,"blurHeight":0};